import PropTypes from 'prop-types';

const CAPTCHA_LEVELS = Object.freeze({
    INVISIBLE: 'invisible',
    VISIBLE: 'visible',
    STEP_UP: 'step_up',
});

const KNOWN_LEVELS = Object.freeze(Object.values(CAPTCHA_LEVELS));

const CHALLENGE_SHAPE = PropTypes.shape({
    level: PropTypes.oneOf(KNOWN_LEVELS).isRequired,
    siteKey: PropTypes.string.isRequired,
    tokenMaxAgeSeconds: PropTypes.number,
});

function buildChallenge(level, siteKey, tokenMaxAgeSeconds) {
    return {
        level: KNOWN_LEVELS.includes(level) ? level : CAPTCHA_LEVELS.VISIBLE,
        siteKey: typeof siteKey === 'string' ? siteKey : '',
        tokenMaxAgeSeconds: Number.isInteger(tokenMaxAgeSeconds) && tokenMaxAgeSeconds > 0
            ? tokenMaxAgeSeconds
            : null,
    };
}

function readChallengeFromDataset(dataset) {
    return buildChallenge(
        dataset ? dataset.captchaLevel : undefined,
        dataset ? dataset.captchaSiteKey : undefined,
        dataset ? Number(dataset.captchaTokenMaxAgeSeconds) : undefined,
    );
}

function readChallengeFromResponse(rawChallenge, currentChallenge) {
    if (!rawChallenge || typeof rawChallenge !== 'object') {
        return currentChallenge;
    }

    return buildChallenge(rawChallenge.level, rawChallenge.site_key, rawChallenge.token_max_age_seconds);
}

function needsVisibleWidget(challenge) {
    return challenge.level !== CAPTCHA_LEVELS.INVISIBLE;
}

export {
    CAPTCHA_LEVELS,
    CHALLENGE_SHAPE,
    buildChallenge,
    readChallengeFromDataset,
    readChallengeFromResponse,
    needsVisibleWidget,
};
